module.exports = __webpack_public_path__ + "img/c70.bb350dfb.png";